import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import Tippy from '@tippyjs/react';
import { CommentItem } from './types';
import { useCommentActions } from './commentActions';

interface CommentControlsProps {
  comment: CommentItem;
  actionHandler: (action: string, e: React.MouseEvent) => void;
  setMenuOpen?: (open: boolean) => void;
}

export const CommentControls = ({ comment, actionHandler }: CommentControlsProps) => {
  const { t } = useTranslation(['comments', 'common']);

  const { canEdit, canToggleStatus, canDelete } = useCommentActions(comment);
  const [areYouSure, setAreYouSure] = useState(false);
  return (
    <div className="comment--controls">
      {canEdit && (
        <div className="comment--controls--item" onClick={(e) => actionHandler('edit', e)}>
          <i className="fa-regular fa-pen"></i>
          <p>{t('comments:edit')}</p>
        </div>
      )}
      {canToggleStatus && (
        <div className="comment--controls--item" onClick={(e) => actionHandler(comment?.closedAt ? 'open' : 'close', e)}>
          <i className={`fa-regular ${comment?.closedAt ? 'fa-folder-open' : 'fa-box-archive'}`}></i>
          <p>{t(`common:${comment?.closedAt ? 'open' : 'close'}`)}</p>
        </div>
      )}
      {canDelete && (
        <Tippy
          disabled={comment?.responses?.length === 0 || comment?.onType === 'comment'}
          content={<p className="gaby-tooltip arrow-bottom">{t('comments:delete-tooltip')}</p>}
        >
          <div
            className={`comment--controls--item ${(comment?.responses?.length ?? 0) > 0 ? 'disabled' : ''}`}
            onClick={(e) => {
              if ((comment?.responses?.length ?? 0) > 0) return;
              e.stopPropagation();
              setAreYouSure(true);
            }}
          >
            <i className="fa-solid fa-trash-can"></i>
            <p>{t('common:delete')}</p>
          </div>
        </Tippy>
      )}
      {areYouSure && (
        <div className="comment--controls--confirm">
          <p>{t('comments:delete-confirm')}</p>
          <div className="comment--controls--inner">
            <button className="comment--confirm--button" onClick={(e) => actionHandler('delete', e)}>
              <i className="fa-solid fa-trash-can"></i>
              <p>{t('common:delete')}</p>
            </button>
            <button
              className="not-a-button"
              onClick={(e) => {
                e.stopPropagation();
                setAreYouSure(false);
              }}
            >
              {t('common:button.cancel')}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
